jQuery(function ($) {
    // Enregistrement des écouteurs si on est sur la bonne page
    if ($("#send-form-payfip").length > 0) {
        // Écouteur de la validation des informations de paiement
        $("#send-form-payfip:not(.disabled)").on("click", function () {
            const $this = $(this);
            $this.addClass("disabled");

            // Reset des messages d'erreurs
            $("#form-success-ajax").html("").addClass("d-none");
            $("#form-error-ajax").html("").addClass("d-none");
            $("#payfip-container-test").addClass("d-none");

            // Vérification des données
            let data = {};
            const goodForm = verifPayfipForm(data);

            // Si les données sont correctes
            if (goodForm) {
                // Récupération des datas pour la requête AJAX
                const $form = $("#form_payfip");
                const url = $form.data('action');

                const formData = {
                    action: 'process_form_payfip',
                    nonce: $("#payfip-nonce").val(),
                    payfip: data
                };

                // Envoi des données
                $.post(url, formData, function (response) {
                    // Si erreur
                    if (!response.success) {
                        $("#form-error-ajax").html(response.data).removeClass("d-none");
                        $this.removeClass("disabled");
                    } else {
                        // Si OK
                        $("#form-success-ajax").html(response.data.message).removeClass("d-none");
                        const payfipId = response.data.payfipId;
                        const payfipUrl = response.data.payfipUrl;
                        // On ouvre une nouvelle fenêtre avec l'URL PayFiP
                        window.open(payfipUrl, '_blank');

                        /* *** Envoi de la requête moulinant pour récupérer le retour de PayFiP *** */
                        if(false) {
                            // Data pour la seconde requête AJAX
                            const verifRetourData = {
                                action: 'payfip_verification_retour',
                                payfipId: payfipId
                            };

                            /* Envoi de la erquête AJAX pour vérifier le retour du paiement */
                            /** TODO : modifier les messages de retour ? **/
                            $.post(url, verifRetourData, function (response) {
                                if (response.success) {
                                    processed = true;
                                    $("#form-success-ajax").html("Le paiement a été accepté.");
                                } else if (!response.success) {
                                    $("#form-success-ajax").addClass("d-none");
                                    let messageErreur = 'Le paiement n\'a pas abouti.'
                                    if (response.data) {
                                        messageErreur += ' ' + response.data;
                                    }
                                    $("#form-error-ajax").html(messageErreur).removeClass("d-none");
                                }
                            });
                        }
                    }
                });
            } else {
                $this.removeClass("disabled");
            }
        });

        /* Vérification des champs du formualaire */
        function verifPayfipForm(data) {
            // data.referenceFacture = '';
            // data.montant = 'etzet';
            // data.email = 'etzet';
            // data.confirmationEmail = 'etzet';
            // return true;
            let goodForm = true;
            const formErrorStyleClass = 'input-error';

            const $ref = $("#payfip-reference-facture");
            const $montant = $("#payfip-montant");
            const $email = $("#payfip-email");
            const $confirmationEmail = $("#payfip-confirmation-email");

            if ($ref.val() == '') {
                goodForm = false;
                $ref.addClass(formErrorStyleClass);
                $("#form-empty-ref").removeClass("d-none");
            } else {
                data.referenceFacture = $ref.val();
                $ref.removeClass(formErrorStyleClass);
                $("#form-empty-ref").addClass("d-none");
            }

            const montant = $montant.val().replaceAll(',', '.');

            console.log(montant);
            if (montant == '') {
                goodForm = false;
                $montant.addClass(formErrorStyleClass);
                $("#form-error-montant").removeClass('d-none');
            } else if (isNaN(montant)) {
                goodForm = false;
                $montant.addClass(formErrorStyleClass);
                $("#form-error-montant").removeClass('d-none');
            } else {
                data.montant = montant;
                $montant.removeClass(formErrorStyleClass);
                $("#form-error-montant").addClass('d-none');
            }

            let validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
            if ($email.val() == '') {
                goodForm = false;
                $email.addClass(formErrorStyleClass);
                $("#form-error-email").removeClass('d-none');
            } else if (!$email.val().match(validRegex)) {
                goodForm = false;
                $email.addClass(formErrorStyleClass);
                $("#form-error-email").removeClass('d-none');
            } else {
                data.email = $email.val();
                $("#form-error-email").addClass('d-none');
                $email.removeClass(formErrorStyleClass);
            }

            if ($confirmationEmail.val() == '') {
                goodForm = false;
                $confirmationEmail.addClass(formErrorStyleClass);
            } else {
                $confirmationEmail.removeClass(formErrorStyleClass);
            }

            if ($email.val() != $confirmationEmail.val()) {
                goodForm = false;
                $confirmationEmail.addClass(formErrorStyleClass);
                $("#form-error-confirm-email").removeClass("d-none");
            } else {
                data.confirmationEmail = $confirmationEmail.val();
                $confirmationEmail.removeClass(formErrorStyleClass);
                $("#form-error-confirm-email").addClass("d-none");
            }
            return goodForm;
        }

    }
})